import { useState, useEffect } from 'react'
import { RecipeCard } from '@client'
// ----------------------------------------------------------------------

export default function RecommendedRecipes({ recipes, activeRecipe }) {
  const [similarRecipes, setSimilarRecipes] = useState([])
  const [recommended, setRecommended] = useState([])

  useEffect(() => {
    if (!recipes) return
    const getSimilarRecipes = () => {
      const selectedFlavor = activeRecipe.cocktail_styles[0]
      const similar = recipes.filter(({ cocktail_styles = [] }) =>
        cocktail_styles.some((style) => style.name === selectedFlavor.name)
      )

      setSimilarRecipes(similar)
    }
    getSimilarRecipes()
  }, [])

  useEffect(() => {
    if (!similarRecipes.length) return
    const getRecommendation = () => {
      function shuffle(array) {
        let currentIndex = array.length,
          randomIndex
        // While there remain elements to shuffle.
        while (currentIndex != 0) {
          // Pick a remaining element.
          randomIndex = Math.floor(Math.random() * currentIndex)
          currentIndex--
          // And swap it with the current element.
          ;[array[currentIndex], array[randomIndex]] = [
            array[randomIndex],
            array[currentIndex]
          ]
        }
        return array
      }
      shuffle(similarRecipes)

      let recommendation = similarRecipes.slice(0, 4)

      setRecommended(recommendation)
    }

    getRecommendation()
  }, [similarRecipes])

  const times = (x) => (f) => {
    if (x > 0) {
      f()
      times(x - 1)(f)
    }
  }

  return (
    <section className='container grid grid-cols-2 gap-6 md:grid-cols-4'>
      {recommended?.length > 0 &&
        recommended.map((recipe, i) => {
          return <RecipeCard key={`${recipe.slug}_${i}`} recipe={recipe} />
        })}
    </section>
  )
}
